import React from "react"
import { VStack, Text, Button, Link, Alert, Box } from "@chakra-ui/react"
import { ExternalLinkIcon } from "@chakra-ui/icons"
import { WalletFill } from "component/Icon"
import { MotionVStack } from "../"
import { PoolInfo } from "../PoolInfo"
import { Global } from "container/global"

export function Intro() {
    const {
        actions: { toggleWalletModal },
    } = Global.useContainer()

    return (
        <MotionVStack bgColor="#F4F4F4" overflow="hidden" w="100%" spacing={5} p={7}>
            <Button
                colorScheme="orange"
                leftIcon={<WalletFill boxSize="20px" />}
                bgColor="orange.400"
                isFullWidth
                onClick={toggleWalletModal}
            >
                Connect Wallet
            </Button>
            <VStack spacing={5}>
                <Alert>
                    <Box>
                        The Staking Program has ended and all PERP holders should migrate to the new Token for rewards.{" "}
                        <br />
                        <Link fontWeight={"bold"} color="perpetual.700" as="a" href="https://token.perp.com">
                            Go to token.perp.com
                        </Link>
                    </Box>
                </Alert>
                <Text color="#808080">
                    Stake your tokens to receive rewards in PERP and a portion of transaction fees from the exchange.
                </Text>

                <Text color="rgba(0,0,0,0.2)">
                    <Link href="https://perp.exchange" fontSize="sm" color="perpetual.500" isExternal mr={1}>
                        Exchange <ExternalLinkIcon mx="2px" />
                    </Link>{" "}
                    |{" "}
                    <Link
                        href="https://docs.perp.fi/getting-started/staking"
                        fontSize="sm"
                        color="perpetual.500"
                        isExternal
                        ml={1}
                    >
                        Docs <ExternalLinkIcon mx="2px" />
                    </Link>
                </Text>

                <PoolInfo />
            </VStack>
        </MotionVStack>
    )
}
